import { render } from "./Identification.vue?vue&type=template&id=395211fc&scoped=true&ts=true"
import script from "./Identification.vue?vue&type=script&lang=ts"
export * from "./Identification.vue?vue&type=script&lang=ts"

import "./Identification.vue?vue&type=style&index=0&id=395211fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395211fc"]])

export default __exports__